import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ApiResponse } from '../../models/common.model';
import { loadDiscount, loadDiscountFailure, loadDiscountSuccess } from './nearby.action';
import { CustomerService } from '../../services/customer.service';

@Injectable()
export class NearbyEffects {
  constructor(
    private actions$: Actions,
    private customerService: CustomerService
  ) { }

  // Effect to load discount
  loadDiscount$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadDiscount),
      switchMap((action: { filter: any }) =>
        this.customerService.getDiscount({ filter: action.filter }).pipe(
          map((response: ApiResponse) => {
            const discountData = response.body || {
              id: null,
              title: '',
              description: '',
              banner_image: '',
              DiscountLists: [],
              contentLists: [],
            };
            if (discountData) {
              discountData.filter = action.filter;
            }

            discountData.contentLists = discountData.contentLists?.sort((a: any, b: any) => a.id - b.id);

            console.log(discountData, "discountData")

            return loadDiscountSuccess({ discountData });
          }),
          catchError((error) =>
            of(
              loadDiscountFailure({
                error: {
                  message: error.message || 'An unknown error occurred',
                  statusCode: error.status || 500,
                },
              })
            )
          )
        )
      )
    )
  );
}

